import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MEALOPS_LOGO_MARK_GREEN } from '@/assets/logos';
import Button from 'components/ui/custom/Button';

// Shown in place of a coach-only page to a signed-out visitor. A bare
// /restaurant/:id (or one with a made-up ?sharedView value) used to render the
// coach header over a raw "permission denied for table restaurants" error.
const SignInPrompt = ({
  title = 'Sign in to view this menu',
  message = "Restaurant menus are part of a coach's MealOps account. Sign in to see this one, or open the cart or poll link your coach sent you.",
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-athletic-lg p-6 text-center">
        <div className="mx-auto mb-4 w-12 h-12 bg-primary rounded-xl flex items-center justify-center shadow-athletic">
          <img src={MEALOPS_LOGO_MARK_GREEN} alt="MealOps" className="h-12 w-auto rounded-md" />
        </div>
        <h1 className="text-xl font-heading font-semibold text-foreground">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{message}</p>
        <Button
          className="mt-6"
          fullWidth
          iconName="LogIn"
          onClick={() => navigate('/login-registration', { state: { from: location } })}
        >
          Sign in
        </Button>
      </div>
    </div>
  );
};

export default SignInPrompt;
